import React from "react";
import { Box, Button } from "@mui/material";
import { Modes, Modes as DialogModes } from "./UserDocumentDialog";
import { UserDocument } from "../../models/UserDocument";
import { PDFDownloadDisclaimer } from "views/shared/dialog/PDFDownloadDisclaimer";

export interface Props {
  document: UserDocument;
  documentSrc: string;
  setMode: (mode: Modes) => void;
}

export const ViewUserDocument = ({
  document,
  documentSrc,
  setMode,
}: Props): JSX.Element => {
  const renderUserDocument = (): JSX.Element | null | undefined => {
    switch (document?.version?.ext) {
      case "png":
      case "gif":
      case "jpg":
        return <RenderImage document={document} documentSrc={documentSrc} />;
      case "pdf":
        return (
          <RenderPdf
            documentSrc={documentSrc}
            style={{ minHeight: "75vh", height: "75vh" }}
            withDisclaimer={true}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        height: "90%",
      }}
    >
      <Box
        sx={{
          flexGrow: 1,
          textAlign: "center",
          minHeight: document?.version?.ext === "pdf" ? "75vh" : "300px",
          maxHeight: 1000,
        }}
      >
        {renderUserDocument()}
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-around",
          py: 1,
        }}
      >
        <Button
          variant="outlined"
          color="secondary"
          size="small"
          onClick={() => setMode(DialogModes.edit)}
        >
          Back to Edit
        </Button>
      </Box>
    </Box>
  );
};

const RenderImage = ({
  documentSrc,
  document,
}: {
  document: UserDocument;
  documentSrc: string;
}) => {
  return (
    <img
      src={documentSrc}
      alt={document?.version?.title}
      style={{
        maxWidth: "100%",
      }}
    />
  );
};

export const RenderPdf = ({
  documentSrc,
  style,
  withDisclaimer,
}: {
  documentSrc: string;
  style?: any;
  withDisclaimer?: boolean;
}): JSX.Element => {
  return (
    <div style={{ position: "relative" }}>
      <object
        style={{
          border: "0",
          minWidth: "300px",
          width: "100%",
          ...style,
        }}
        data={documentSrc}
        type="application/pdf"
      >
        <iframe
          src={documentSrc}
          style={{
            border: "0",
            minWidth: "300px",
            width: "100%",
            ...style,
          }}
        >
          This browser does not support PDFs. Please download the PDF to view it
        </iframe>
      </object>
      {withDisclaimer && <PDFDownloadDisclaimer />}
    </div>
  );
};
